const WORKSPACE_RESOURCE_ROUTE_OVERRIDES: Readonly<Record<string, string>> = {
    dashboards: '/relations/dashboards',
    lists: '/relations/lists',
    teams: '/settings/workspace/permissions/teams',
};

const WORKSPACE_RESOURCE_COLLECTION_NAMES: Readonly<Record<string, string>> = {
    dashboard: 'dashboards',
    folder: 'folders',
    investment: 'investments',
    list: 'lists',
    memo: 'memos',
    notebook: 'notebooks',
    pipeline: 'pipelines',
    team: 'teams',
};

export const getWorkspaceResourceCollectionRoute = (resourceType: string): string => {
    const collectionName = WORKSPACE_RESOURCE_COLLECTION_NAMES[resourceType] ?? resourceType;

    return WORKSPACE_RESOURCE_ROUTE_OVERRIDES[collectionName] ?? `/${collectionName}`;
};

export const getWorkspaceResourceDetailRoute = (resourceType: string, resourceId: string): string => {
    const baseRoute = getWorkspaceResourceCollectionRoute(resourceType);

    return `${baseRoute}/${encodeURIComponent(resourceId)}`;
};
